import { render, staticRenderFns } from "./taxOrder.vue?vue&type=template&id=76071efc&scoped=true"
import script from "./taxOrder.vue?vue&type=script&lang=js"
export * from "./taxOrder.vue?vue&type=script&lang=js"
import style0 from "./taxOrder.vue?vue&type=style&index=0&id=76071efc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76071efc",
  null
  
)

export default component.exports